module.exports = __webpack_public_path__ + "static/media/lppolice.dc984545.ico";


//////////////////
// WEBPACK FOOTER
// ./src/images/lppolice.ico
// module id = 1909
// module chunks = 0